<template>
  <slice
    :id="block._key"
    class="slice--cta-video"
    :class="[block.is_full ? 'full' : 'container']"
  >
    <div class="row-md justify-center">
      <div :class="block.is_full ? 'col-md-12' : 'col-md-10 col-xlg-12'">
        <component
          :is="linkComponent(block.link)"
          v-if="block.link"
          :to="url"
          :href="url"
          data-cy-link
          @click.native="activateLoading"
        >
          <div class="slice-video">
            <client-only>
              <div class="slice-video__container">
                <div
                  class="slice-video__container__inner"
                  :style="{
                    width: `${videoSize.width}px`,
                    height: `${videoSize.height}px`,
                  }"
                >
                  <video-bunny
                    :src="`https://iframe.mediadelivery.net/embed/${videoFolder}/${videoId}?autoplay=true&loop=true&muted=true`"
                  />
                </div>
              </div>
            </client-only>
          </div>

          <cta-content :block="block" :loading-button="loadingButton" />
        </component>
      </div>
    </div>
  </slice>
</template>

<script>
import NuxtSSRScreenSize from 'nuxt-ssr-screen-size'
import CtaContent from './cta/CtaContent'

import Slice from '@/components/Slices/Slice'
import VideoBunny from '~/components/video/bunny.vue'

import { BUNNY_STREAM_FOLDERS } from '@/const'

export default {
  name: 'BlockCtaVideo',
  components: {
    Slice,
    VideoBunny,
    CtaContent,
  },
  mixins: [NuxtSSRScreenSize.NuxtSSRScreenSizeMixin],
  props: {
    block: { type: Object, required: true },
    firstSlice: { type: Boolean, default: false },
  },
  data: () => ({ loadingButton: false }),
  computed: {
    videoFolder() {
      if (this.block.videoMobile && this.block.video) {
        return this.$vssWidth < 769
          ? BUNNY_STREAM_FOLDERS[this.block.videoMobile.folder]
          : BUNNY_STREAM_FOLDERS[this.block.video.folder]
      }

      if (this.block.video) {
        return BUNNY_STREAM_FOLDERS[this.block.video.folder]
      }

      return BUNNY_STREAM_FOLDERS[this.block.videoMobile.folder]
    },
    videoId() {
      if (this.block.videoMobile && this.block.video) {
        return this.$vssWidth < 769
          ? this.block.videoMobile.id
          : this.block.video.id
      }

      if (this.block.video) {
        return this.block.video.id
      }

      return this.block.videoMobile.id
    },
    videoRatio() {
      if (this.block.videoMobile && this.block.video) {
        return this.$vssWidth < 769
          ? this.block.videoMobile.ratio
          : this.block.video.ratio
      }

      if (this.block.video) {
        return this.block.video.ratio
      }

      return this.block.videoMobile.ratio
    },
    videoSize() {
      let ratio

      if (this.videoRatio) {
        ratio = this.videoRatio.width / this.videoRatio.height
      } else if (this.$vssWidth < 769) {
        ratio = 9 / 16
      } else {
        ratio = 16 / 9
      }

      const screenRatio = this.$vssWidth / this.$vssHeight

      if (screenRatio <= ratio) {
        return {
          width: Math.round(this.$vssHeight * ratio),
          height: this.$vssHeight,
        }
      }

      return {
        width: this.$vssWidth,
        height: Math.round(this.$vssWidth / ratio),
      }
    },
    hasTitle() {
      return this.block.title && this.block.title.length > 0
    },
    hasAccroche() {
      return this.block.accroche && this.block.accroche.length > 0
    },
    url() {
      if (this.block.link.type === 'external') {
        return this.block.link.url
      }

      return this.$contextSanityPath(this.block.link.internalLink)
    },
  },
  methods: {
    activateLoading() {
      this.loadingButton = true
    },
    linkComponent(link) {
      return link.type === 'external' ? 'a' : 'nuxt-link'
    },
  },
}
</script>

<style lang="scss">
.slice--cta-video {
  .slice-video {
    height: 100svh;
    min-height: rem(550px);

    &__container {
      position: absolute;
      inset: 0;
      pointer-events: none;
      overflow: hidden;

      &__inner {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        min-height: 100%;
        min-width: 100%;
      }
    }
  }

  .cta-content__title {
    font-family: var(--secondary-font-family);
    font-size: var(--countdown-font-size);
    margin-bottom: calc(var(--spacing) * 0.2);
    line-height: 1;

    @include mq($from: tablet) {
      margin-bottom: calc(var(--spacing) * 1.4);
    }

    + .cta-content__btn {
      @include mq($until: tablet) {
        margin-top: calc(var(--spacing) * 1.3);
      }
    }
  }
}
</style>
